module.exports = __webpack_public_path__ + "img/jo2.91bd2f2c.png";